/* Open Road · FAQ accordion
   Vanilla, no deps. Two behaviours, both per [data-faq-root]:
   1. Exclusive open  — when data-exclusive="true", opening one <details> closes its
      siblings (the shared name= attribute covers modern browsers; this covers older ones).
   2. Live search     — layout "search": filter <details> items by text, keep a running
      count, and toggle a branded empty state when nothing matches.
   Native <details>/<summary> means the accordion works with JS off; this only enhances. */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('details.acc-item'));

    /* ---- Exclusive open ---- */
    if (root.getAttribute('data-exclusive') === 'true') {
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }

    /* ---- Live search ---- */
    var input = root.querySelector('[data-faq-search]');
    if (!input) return;

    var countEl = root.querySelector('[data-faq-count]');
    var emptyEl = root.querySelector('[data-faq-empty]');
    var total = items.length;
    var template = countEl ? (countEl.getAttribute('data-count-label') || '') : '';

    function setCount(shown, query) {
      if (!countEl) return;
      if (!query) {
        countEl.textContent = template.replace('{n}', total);
      } else {
        countEl.textContent = shown + ' of ' + total + ' match “' + query + '”';
      }
    }

    function apply() {
      var raw = input.value.trim();
      var query = raw.toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var match = query === '' || item.textContent.toLowerCase().indexOf(query) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });
      var empty = shown === 0;
      root.classList.toggle('is-empty', empty);
      if (emptyEl) emptyEl.hidden = !empty;
      setCount(shown, raw);
    }

    input.addEventListener('input', apply);
    apply();
  }

  function init() {
    var roots = document.querySelectorAll('[data-faq-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when a section is added/reloaded in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-faq-root]');
    if (root) initRoot(root);
  });
})();
